<template>
  <div
    id="home-page"
    class="h-full grid grid-rows-[auto_1fr] overflow-hidden relative"
  >
    <ThreadsNav :show-center="false" show-back />

    <div
      :class="[
        'w-full h-full overflow-x-hidden  hide-scroll',
        userStore.isLogin ? 'overflow-y-auto' : 'overflow-y-hidden',
      ]"
    >
      <div class="flex flex-col gap-2">
        <div class="pb-2">
          <PlanetOverview
            v-if="userStore.isLogin"
            class="bg-base-200/40"
            show-header-big-worldview
          />
          <div v-else class="flex relative pt-5">
            <img src="/img/demo-home.png" alt="" class="w-full h-full" />
            <div class="absolute bottom-0 left-0 right-0 top-0 bg-black/50" />
            <div
              class="absolute bottom-0 left-0 right-0 top-0 flex flex-col items-center gap-4 pt-24 px-10"
            >
              <p class="text-white text-center">
                {{ $t("Message.registerToStart") }}
              </p>
              <button
                class="btn btn-primary"
                @click="userStore.openLoginModal('register')"
              >
                {{ $t("Buttons.registerOrLogin") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DungeonsHomeMyMateModal v-model:show="showOCEditor" />
  </div>
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { ref } from "vue";
const userStore = useGlobalUser();

const showOCEditor = ref(false);
</script>

<style>
.hide-scroll::-webkit-scrollbar {
  display: none;
}
</style>
